import { z } from 'zod';

/** A flag do feature-flag-service (`currentFeatures(system: USER_APP)`) que a corrida com a
 *  99 lê: só o atalho de ajuda dentro da corrida. A `mobility_99` não libera mais a corrida
 *  (#7330). */
export const MOBILITY_99_FEATURE_FLAGS = ['mobility_99_help_center'] as const;

export interface Mobility99AccessInput {
  /** `policyAccess` contém `mobility`; `null` = não resolvido. */
  mobilityPolicy: boolean | null;
  /** `policyGetAccessModal.smartMobility`; `null` = não resolvido. */
  smartMobility: boolean | null;
  /** `currentFeatures(USER_APP)` filtradas; `null` = não resolvido. */
  featureFlags: readonly string[] | null;
}

export const Mobility99EntrySchema = z
  .object({ offer: z.boolean(), helpCenter: z.boolean() })
  .strict();
export type Mobility99Entry = z.infer<typeof Mobility99EntrySchema>;

const HIDDEN: Mobility99Entry = { offer: false, helpCenter: false };

/**
 * Se a corrida com a 99 aparece: a barra "CORRIDAS" da home nova do app
 * (`get_mobility_99_home_banner_state.dart`), sem o Smart Mobility (spec §4).
 * Só as políticas decidem: sem a política `mobility` ou sem `smartMobility` ("um checkbox
 * governa a barra", commit `6769d7369` do app), ou com uma delas não resolvida, esconde. A flag
 * legada `mobility_99` não decide mais nada (#7330); as flags só ligam o atalho de ajuda, e não
 * resolvidas o desligam sem esconder a corrida. Gastos bloqueados NÃO entram, como no legado.
 * Canal (app nativo) e a capacidade da ponte ficam no cliente.
 */
export function mobility99Entry(input: Mobility99AccessInput): Mobility99Entry {
  const { mobilityPolicy, smartMobility, featureFlags } = input;
  if (!mobilityPolicy || !smartMobility) return HIDDEN;
  return { offer: true, helpCenter: featureFlags?.includes('mobility_99_help_center') ?? false };
}
